{
  "title": "Título",
  "album": "Album",
  "artist": "Artista",
  "year": "Fecha",
  "comment": "Comentario",
  "synopsis": "Sinopsis",
  "externalLink": "Enlace externo",
  "composer": "Compositor",
  "copyright": "Copyright",
  "size": "Tamaño",
  "bit_rate": "Tasa de bit"
}
